<template>
  <div v-if="field.field_type === 'section_break'">
    <legend v-html="translateIfExist(label)" :class="'body-2 theme--' + mode" />
    <hr class="mt-2 mb-2" />
    <legend v-html="translateIfExist(description)" :class="'theme--' + mode" />
  </div>
  <div v-else class="form-outline">
    <legend v-html="translateIfExist(label)" class="body-2" />
    <hr class="mt-2 mb-2" />
    <legend v-html="translateIfExist(description)" :class="'v-label theme--' + mode" />
  </div>
</template>

<script>
import formsMixin from '../formsMixin';

export default {
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  computed: {
    label() {
      return this.field.label ? this.field.label : '';
    },
    description() {
      return this.field.field_options && this.field.field_options.description ? this.field.field_options.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
    },
  },
};
</script>
